import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

type NewsListItemProps = {
  item: NewsItem;
  showImage?: boolean;
};

export default function NewsListItem({ item, showImage = true }: NewsListItemProps) {
  return (
    <Link
      to={`/article/${item.id}`}
      className="group flex gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
    >
      {showImage && (
        <div className="w-28 h-20 sm:w-36 sm:h-24 shrink-0 rounded-lg overflow-hidden bg-background-200">
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} - 八戒影视资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 text-[11px] font-medium">
            {item.category}
          </span>
          <span className="text-[11px] text-foreground-400">{item.date}</span>
        </div>
        <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 mt-1.5 line-clamp-2 hidden sm:block">{item.summary}</p>
        <span className="text-[11px] text-foreground-400 mt-auto pt-1.5">来源：{item.source}</span>
      </div>
    </Link>
  );
}